var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubAdultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 1,
    fill: "#DE0001"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.442 10.161H17.09V11.708H5.442V10.161ZM6.417 6.95H16.141V8.497H6.417V6.95ZM10.395 5H12.059V17.207H10.395V5ZM10.122 11.058L11.474 11.617C11.162 12.1283 10.8067 12.631 10.408 13.125C10.0093 13.6103 9.576 14.0697 9.108 14.503C8.64867 14.9363 8.16767 15.335 7.665 15.699C7.171 16.0543 6.66833 16.3663 6.157 16.635C6.07033 16.4963 5.95767 16.3447 5.819 16.18C5.689 16.0153 5.55033 15.855 5.403 15.699C5.26433 15.5343 5.13 15.3957 5 15.283C5.50267 15.0663 6.001 14.8063 6.495 14.503C6.99767 14.191 7.47433 13.8487 7.925 13.476C8.37567 13.1033 8.78733 12.7133 9.16 12.306C9.53267 11.89 9.85333 11.474 10.122 11.058ZM12.345 11.071C12.605 11.487 12.9213 11.903 13.294 12.319C13.6753 12.7263 14.0913 13.1163 14.542 13.489C14.9927 13.8617 15.4607 14.204 15.946 14.516C16.44 14.8193 16.934 15.0793 17.428 15.296C17.3067 15.3913 17.1723 15.5213 17.025 15.686C16.8863 15.842 16.752 16.0067 16.622 16.18C16.492 16.3533 16.3837 16.5093 16.297 16.648C15.7943 16.3793 15.296 16.063 14.802 15.699C14.308 15.335 13.8313 14.9363 13.372 14.503C12.9127 14.061 12.4837 13.5973 12.085 13.112C11.695 12.6267 11.344 12.1283 11.032 11.617L12.345 11.071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAdultIcon);
export default __webpack_public_path__ + "static/media/sub-adult-icon.0c19ff5b05b0e0c54ff852fa5463a629.svg";
export { ForwardRef as ReactComponent };